<div tabindex="0" class="me-appointment-booked-card" *ngIf="data">
    <div class="me-appointment-booked-card--title">
        {{data.title}}
    </div>

    <div class="me-appointment-booked-card--description" [innerHTML]="data.body | storyblokRichtext:replaceText"></div>

    <div class="me-appointment-booked-card--btn">
        <button class="btn btn--primary w-100" (click)="joinAppointment()">
            {{data.joinAppointmentButton}}
        </button>
    </div>
</div>